import MainLayout from "Layouts/Main";
import React, { useState } from "react";
import "./styles.scss";
import NormalTabs from "Components/Tabs";
import ProfileSettings from "./ProfileSettings";
import NotificationSettings from "./NotificationSettings";
import ChangePassword from "./ChangePassword";

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = ["Profile Settings", "Notification Settings", "Change Password"];
  const handleTabChange = (index) => {
    setActiveTab(index);
  };
  return (
    <MainLayout>
      <div className="assessor-setting-container ps-4 ms-2">
        <div className="settingsLabel">Settings</div>
        <div className="mt-4 tabsWrap py-4">
          <NormalTabs
            tabs={tabs}
            activeTab={activeTab}
            handleTab={handleTabChange}
          />

          {activeTab === 0 && (
            <ProfileSettings goToNextTab={() => handleTabChange(1)} />
          )}
          {activeTab === 1 && (
            <NotificationSettings goToNextTab={() => handleTabChange(2)} />
          )}
          {activeTab === 2 && (
            <ChangePassword goToNextTab={() => handleTabChange(0)} />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default Settings;
